import { render, staticRenderFns } from "./personStatic.vue?vue&type=template&id=7085131e&scoped=true&"
import script from "./personStatic.vue?vue&type=script&lang=js&"
export * from "./personStatic.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/evaluation/static.less?vue&type=style&index=0&id=7085131e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7085131e",
  null
  
)

component.options.__file = "personStatic.vue"
export default component.exports